import { SEARCH_BIKE_MODEL_REQUEST, SEARCH_BIKE_MODEL_REQUEST_SUCCESS, SEARCH_BIKE_MODEL_REQUEST_FAILURE } from '../constants/bike_model.constants';

export const searchBikeModelRequest = (value, brand_id) => ({
    type: SEARCH_BIKE_MODEL_REQUEST, value, brand_id,
});

export const searchBikeModelRequestSuccess = payload => ({
    type: SEARCH_BIKE_MODEL_REQUEST_SUCCESS, payload,
});

export const searchBikeModelRequestFailure = error => ({
    type: SEARCH_BIKE_MODEL_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/search_bike_model.actions.js